import { Component, HostBinding, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { GlobalFunction } from "../../../../routes/services/globalFuntion";
import { TranslatorService } from "../../../../core/translator/translator.service";
import * as moment from "moment";

@Component({
  selector: "app-monitor-alert",
  templateUrl: "./monitor.html",
  styleUrls: ["./monitor.scss"]
})
export class MonitorAlertsComponent implements OnInit {
  @Input() alert;
  @Input() feeder;
  @Output("individualFeeder") individualFeeder = new EventEmitter();
  @Input("timezone") timezone;
  /**
   * Distribucion apilada: titulo (y acciones proyectadas) en una fila y las
   * respuestas centradas en la fila de abajo. Por defecto false para no
   * alterar el panel de estanques.
   */
  @HostBinding("class.is-stacked") @Input() stacked = false;
  constructor(public globalFunction: GlobalFunction, public translatorService: TranslatorService) {}

  ngOnInit(): void {}
  individualAction(alert) {
    this.individualFeeder.emit({ data: alert, feeder: this.feeder });
  }

  /**
   * Traduce el modo de frecuencia de lectura de sensores que reporta el equipo.
   * @param frecuency Modo reportado por el alimentador (0 a 3).
   * @returns Texto traducido del modo.
   */
  validateFrecuencyMode = (frecuency) => {
    const claves = {
      0: "panel-alerts.monitor.frequency-disabled",
      1: "panel-alerts.monitor.frequency-hourly",
      2: "panel-alerts.monitor.frequency-3-hours",
      3: "panel-alerts.monitor.frequency-5-hours"
    };
    const clave = claves[frecuency];
    return clave ? this.translatorService.translate(clave) : "";
  };

  validateActive(val, type = "") {
    if (val) {
      return "bg-alert-success";
    } else if (type === "power" || type === "dispenser") {
      return "bg-alert-danger";
    } else {
      return "bg-alert-secondary";
    }
  }

  validateText(alert) {
    switch (alert) {
      case "monitor":
        return this.translatorService.translate("testing.alarm-test");
      case "battery":
        return this.translatorService.translate("testing.battery-test");
      case "panel":
        return this.translatorService.translate("testing.panel-test");
      case "signal":
        return this.translatorService.translate("testing.request-signal");
      case "reset":
        return this.translatorService.translate("testing.alerts-reset");
      case "version":
        return this.translatorService.translate("testing.request-version");
      case "refeed":
        return this.translatorService.translate("testing.resend-ration");
      case "empty":
        return this.translatorService.translate("testing.empty-feeder");
      case "turn_on":
        return this.translatorService.translate("testing.turn-on");
      case "turn_off":
        return this.translatorService.translate("testing.turn-off");
      case "turn_off_spin_time":
        return this.translatorService.translate("testing.turn_off_spin_time");
      case "turn_on_spin_time":
        return this.translatorService.translate("testing.turn_on_spin_time");

      default:
        return this.translatorService.translate("testing.alarm-test");
    }
  }
  validateColorImage = (data, type, success, warning, danger) => {
    let { dispenser, sprinkler, panel, battery } = data;

    if (type === "battery") {
      if (battery > 12.5) {
        return success;
      }
      if (battery > 11.5 && battery <= 12.5) {
        return warning;
      }
      if (battery <= 11.5) {
        return danger;
      }
    }
    if (type === "panel") {
      if (panel > 15) {
        return success;
      }
      if (panel > 12 && panel <= 15) {
        return warning;
      }
      if (panel <= 12) {
        return danger;
      }
    }
    if (type === "sprinkler") {
      return sprinkler ? danger : success;
    }
    if (type === "dispenser") {
      return dispenser ? danger : success;
    }

    return danger;
  };
  validateAlert(alert) {
    let bool = true;
    if (alert.hasOwnProperty("battery")) {
      if (alert.battery <= 11.5) {
        return false;
      }
    }
    if (alert.hasOwnProperty("panel")) {
      if (alert.panel <= 12) {
        return false;
      }
    }
    if (alert.hasOwnProperty("dispenser")) {
      return !alert.dispenser;
    }
    if (alert.hasOwnProperty("sprinkler")) {
      return !alert.sprinkler;
    }

    return bool;
  }
  /**
   * Da formato de dos dígitos (HH:mm:ss) al tiempo transcurrido de la alerta.
   * @param value Tiempo transcurrido sin padding, ej. "2:5:9"
   * @returns Tiempo formateado con dos dígitos por segmento, ej. "02:05:09"
   */
  formatDuration(value: string): string {
    if (!value) {
      return value;
    }
    return value
      .split(":")
      .map((segment) => segment.padStart(2, "0"))
      .join(":");
  }

  /**
   * Combina la fecha y hora de la alerta y las trata como UTC real, ya que el
   * backend las guarda en UTC pero no convierte la hora al regresarlas.
   * @param alert Alerta con alert.data.date y alert.data.time
   * @returns Fecha ISO en UTC lista para usarse con el pipe date y el timezone de la granja
   */
  convertTimeZone(alert) {
    if (alert && alert.data && alert.data.time && alert.data.date) {
      const { time, date } = alert.data;
      return moment.utc(`${date} ${time}`).toISOString();
    }
    return "";
  }
}
